// ANCHOR React
import { FormEvent } from 'react';

// ANCHOR Models
import {
  useUpdateFormQuestionAnswerCount,
} from '@lyon/scoped-models/form/update/UpdateFormQuestionForm';
import { useFormQuestionAnswersData } from '@lyon/scoped-models/form/FormQuestionAnswersData';

// ANCHOR Hooks
import { useConstantCallback } from '@lyon/utils/hooks/useConstantCallback';

// ANCHOR Components
import { constant } from '@lyon/components/utils/constant';
import { FormField } from '@lyon/components/utils/FormField';

// ANCHOR Constants
import { TITLE } from './constants';

export const LyonUpdateCheckboxAnswerCount = constant(() => {
  const answers = useFormQuestionAnswersData();
  const [answerCount, setAnswerCount] = useUpdateFormQuestionAnswerCount();

  const onChange = useConstantCallback((event: FormEvent<HTMLInputElement>) => {
    const value = Number.parseInt(event.currentTarget.value, 10);

    setAnswerCount(Number.isNaN(value) ? undefined : value);
    event.stopPropagation();
  });

  return (
    <FormField
      value={answerCount ?? ''}
      label={TITLE}
      onChange={onChange}
      placeholder={String(answers?.length ?? 1)}
    />
  );
});
